import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import NotFound from '../pages/NotFound';

interface ContactBlockedRouteProps {
  children: React.ReactElement;
}

/**
 * Route guard that blocks contact users from accessing certain routes.
 * Contact users will see the NotFound page when trying to access blocked routes.
 * Non-contact users can access these routes normally.
 */
const ContactBlockedRoute: React.FC<ContactBlockedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // Check if user is a contact user
  const isContactUser = user?.class?.toLowerCase() === 'contact';

  // If contact user, show NotFound page
  if (isContactUser) {
    return <NotFound />;
  }

  return children;
};

export default ContactBlockedRoute;
